import React, { useContext, useEffect, useState } from 'react'
import { CKEditor } from '@ckeditor/ckeditor5-react';
import DatePicker from 'react-multi-date-picker';
import persian from 'react-date-object/calendars/persian';
import persian_fa from 'react-date-object/locales/persian_fa';
import { FaRegWindowClose } from 'react-icons/fa';
import { DataContext } from '../../context/DataProvider';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { CiEdit } from 'react-icons/ci';
import { MdDeleteForever } from 'react-icons/md';
import { IoNewspaperOutline } from 'react-icons/io5';
import { addDays, format as jalaliFormat } from 'date-fns-jalali';
const EditReform = ({Lops,EditFun}) => {
  // const [Lops, setLops] = useState([]);
  const [AllStatus, setAllStatus] = useState([]);
  const [sectionType, setSectionType] = useState([]);
  const {
    tokenLogin,
    isTokenExpired,
    fetchRefreshToken,
    edame,
    ReformInfo,
    setReformInfo,
    ReFormEditFun,
    openEdiModal, setOpenEditModal,OpenCreateModal, setOpenCreateModal,
    openDeleteModalReform, setOpenDeleteModalReform,deleteID, setDeleteID,
    
  
  } = useContext(DataContext);
  const OnChangeCKEitor = (editor, event) => {
    let data = event.getData();
    // console.log(event.getData());
    setReformInfo({
      ...ReformInfo,
      SectionText: data,
    });
  };
  const handleDelete = (id: number) => {
    setOpenDeleteModalReform(true);
    setDeleteID(id);
  };
  // const fetchLops = async (id: number) => {
  //   try {
  //     await fetch(
  //       `${process.env.REACT_APP_BASE_URL}/api/Admin/ListSection?search=${id}`,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${tokenLogin?.AccessToken}`,
  //         },
  //       },
  //     )
  //       .then((res) => res.json())
  //       .then((data) => setLops(data.data))
  //       .finally(() => setLoading(false));
  //   } catch (error) {
  //     console.log('error', error);
  //   }
  // }; 
  const fetchSectionType = async () => {
    await fetch(`${process.env.REACT_APP_BASE_URL}/api/Data/SectoinType`)
      .then((res) => res.json())
      .then((data) => setSectionType(data));
  };
  const fetchStatus = async () => {
    await fetch(`${process.env.REACT_APP_BASE_URL}/api/Data/Status?all=true`)
      .then((res) => res.json())
      .then((data) => setAllStatus(data));
  };
  useEffect(() => {
    fetchSectionType();
    fetchStatus();
    
  }, []);
  const handleChangeDate=(date:{})=>{
    setReformInfo({
      ...ReformInfo,
      ChanegDate:jalaliFormat(new Date(date), 'yyyy/MM/dd')
    })
  }
  const hadleClose=()=>{
    setOpenEditModal(false)
    setReformInfo({
      ID: 0,
      Parent_ID: 0,
      Law_ID: 0,
      SectionText: '',
      Title: '',
      SectionType_ID: 0,
      TextOrder: 0,
      TextOrder2: 0,
      SectionNumber: 0,
      LetterNumber: '',
      SectionTitle: '',
      TextForEdit: '',
      RevisionRistrict: true,
      ChangeDate:'',
      Status:0,
      SectionPath:'',
      })
  }
  const handleOpenCreateModal = () => {
    
    setOpenCreateModal(true);
    setOpenEditModal(false);
    setReformInfo({
      ID: 0,
      Parent_ID: 0,
      Law_ID: 0,
      SectionText: '',
      Title: '',
      SectionType_ID: 0,
      TextOrder: 0,
      TextOrder2: 0,
      SectionNumber: 0,
      LetterNumber: '',
      SectionTitle: '',
      TextForEdit: '',
      RevisionRistrict: true,
      ChangeDate:'',
      Status:0
    });
  };
  return (
   <>
                 <div className="ModalBackground">
                <div className="Modal-innerReform">
                  <div className="w-full ltr">
                    <FaRegWindowClose
                      onClick={hadleClose}
                      className="text-[20px] cursor-pointer"
                    />
                  </div>
                  <div className=" text-[18px] font-bold w-full p-2 text-black font-IranSans">
                    اصلاح ساختار
                  </div>

                  <div className="w-full  border-2 border-[#E5E1DA] rounded-lg p-5">
                    <div className="w-full grid grid-cols-2 gap-3 ">
                      <div className="w-full  items-center justify-center flex ">
                        <label className="font-IranSans  mt-3 w-[30%] text-[14px]">
                          نوع ساختار:
                        </label>
                        <select
                          className="w-[70%] border  outline-none border-body p-2 rounded-md font-IranSans"
                          onChange={(e) =>
                            setReformInfo({
                              ...ReformInfo,
                              SectionType_ID: parseInt(e.target.value),
                            })
                          }
                        >
                          {/* <option value={ReformInfo.SectionType_ID}>
                            {ReformInfo.SectionTitle}
                          </option> */}
                          {sectionType.map((item) => {
                            return item.id === ReformInfo.SectionType_ID ? (
                              <>
                                <option key={item.id} value={item.id} selected>
                                  {item.title}
                                </option>
                              </>
                            ) : (
                              <>
                                {' '}
                                <option key={item.id} value={item.id}>
                                  {item.title}
                                </option>
                              </>
                            );
                          })}
                        </select>
                      </div>
                      <div className="w-full  items-center justify-center flex ">
                        <label className="ml-5 font-IranSans   w-[30%] text-[14px]">
                          سرشاخه :
                        </label>

                        <select
                          className="w-[70%] border outline-none border-body p-2 rounded-md font-IranSans"
                          // defaultValue={ReformInfo.sectionPath}
                          onChange={(e) =>
                            setReformInfo({
                              ...ReformInfo,
                              Parent_ID:
                                e.target.value === 'null'
                                  ? ''
                                  : parseInt(e.target.value),
                            })
                          }
                        >
                          <option value="null"></option>
                          {Lops.map((item) => {
                            return (
                              <>
                                {item.SectionPath == ReformInfo.SectionPath ? (
                                  <>
                                    <option
                                      key={item.ID}
                                      value={item.ID}
                                      selected
                                    >
                                      {item.SectionPath}
                                    </option>
                                  </>
                                ) : (
                                  <>
                                    <option key={item.ID} value={item.ID}>
                                      {item.SectionPath}
                                    </option>
                                  </>
                                )}
                              </>
                            );
                          })}
                        </select>
                      </div>
                      <div className="w-full  items-center justify-center flex font-IranSans ">
                        <label className="ml-5 w-[30%] mt-3 text-[14px]">
                          عنوان ساختار :
                        </label>
                        <input
                          type="text"
                          defaultValue={ReformInfo.Title}
                          className="w-[70%] border mt-3 outline-none border-body p-3 rounded-md "
                          onChange={(e) =>
                            setReformInfo({
                              ...ReformInfo,
                              Title: e.target.value,
                            })
                          }
                        />
                      </div>
                      
                      <div className="w-full font-IranSans  items-center justify-center flex ">
                        <label className="ml-5 mt-3  w-[30%] text-[14px]">
                          ترتیب :
                        </label>
                        <input
                          defaultValue={ReformInfo.TextOrder}
                          type="text"
                          className="w-[70%] border mt-3 outline-none border-body p-3 rounded-md "
                          onChange={(e) =>
                            setReformInfo({
                              ...ReformInfo,
                              TextOrder: parseInt(e.target.value),
                            })
                          }
                        />
                      </div>
                      <div className="w-full font-IranSans  items-center justify-center flex ">
                        <label className="ml-5 mt-3  w-[30%] text-[14px]">
                           ترتیب ثانویه:
                        </label>
                        <input
                          defaultValue={ReformInfo.TextOrder2}
                          type="text"
                          className="w-[70%] border mt-3 outline-none border-body p-3 rounded-md "
                          onChange={(e) =>
                            setReformInfo({
                              ...ReformInfo,
                              TextOrder2: parseInt(e.target.value),
                            })
                          }
                        />
                      </div>
                      <div className="w-full font-IranSans  items-center justify-center flex ">
                        <label className="ml-5 mt-3  w-[30%] text-[14px]">
تاریخ وضعیت 
                        </label>
                        <DatePicker
                  className="custom-calendar"
                  inputClass="custom-input"
                  calendarPosition="bottom-center"
                  value={ReformInfo.ChangeDate}
                  locale={persian_fa}
                  calendar={persian}
                  onChange={handleChangeDate}
                />
                      </div>
                    {/* </div> */}
                    <div className="w-full font-IranSans  items-center justify-center flex ">
                        <label className="ml-5 mt-3  w-[30%] text-[14px]">
وضعیت تنقیحی  
                        </label>
                        <select
                      onChange={(e)=>setReformInfo({...ReformInfo,Status:e.target.value})}
                      className="w-[70%] text-[14px] border font-bold outline-none border-body p-1 rounded-md"
                      // defaultValue={objectEdit.EffectType_ID}
                    >
                      {/* <option>{objectEdit.Status}</option> */}
                      {AllStatus.map((item) => {
                        return (
                          <option
                            key={item.id}
                            value={item.id}
                            className="font-bold"
                          >
                            {item.title}
                          </option>
                        );
                      })}
                    </select>
                      </div>
                    </div>                 
                       <div className="w-full mt-3 items-center font-IranSans justify-between p-3 flex ">
                      <label className="ml-5  w-[6%] text-[14px]">متن :</label>
                      <div className="w-full h-full font-IranSans ">
                        <CKEditor
                          editor={ClassicEditor}
                          data={ReformInfo.SectionText}
                          onChange={OnChangeCKEitor}
                          config={{
                            language: 'fa',
                          }}
                        />
                      </div>
                    </div>
                    <div className=" flex gap-5 w-full mt-5 ltr p-3 font-IranSans">
                      <button
                        className="w-32 p-2  font-IranSans rounded-full flex items-center justify-center text-[14px] hover:border-2 text-white bg-[#65B741] font-bold 
              hover:shadow-2xl hover:shadow-black "
                        onClick={EditFun}
                      >
                        ثبت
                        <CiEdit size={25} className="ml-2" />
                      </button>
                      <button
                        className="w-32 p-2  font-IranSans rounded-full text-[14px] text-white font-bold flex items-center justify-center
             bg-[#F5564E] hover:border-2 hover:shadow-2xl hover:shadow-black"
                        onClick={() => handleDelete(ReformInfo.ID)}
                      >
                        حذف
                        <MdDeleteForever className="ml-3" />
                      </button>
                      <button
                        className="w-32 p-2   font-IranSans rounded-full text-[14px] text-white flex items-center justify-center
             bg-[#867AE9] font-bold hover:border-2 hover:shadow-2xl hover:shadow-black"
                        onClick={handleOpenCreateModal}
                      >
                        جدید <IoNewspaperOutline className="ml-3" />
                      </button>
                    </div>
                  </div>
                  {/* </form> */}
                </div>
              </div>
   
   
   
   </>
  )
}

export default EditReform
